import { createContext, useContext } from 'react';

// The id of a FilterGroup's heading, so the pill set inside the group is
// named by it (aria-labelledby) rather than left an unnamed role="group".
export const FilterGroupLabelContext = createContext<string | undefined>(undefined);

export function useFilterGroupLabelId(): string | undefined {
  return useContext(FilterGroupLabelContext);
}
